import $ from 'jquery';

export default class Header {
    constructor() {
        const $hamburger = $('.nav__hamburger');
        const $menu = $('.nav__links');

        $hamburger.on('click', function () {
            $(this).toggleClass('active');
            $menu.toggleClass('nav__links--open');
        });

        $(document).on('click', function (e) {
            if ($menu.hasClass('nav__links--open') && !$(e.target).closest('.nav__links, .nav__hamburger').length) {
                $hamburger.removeClass('active');
                $menu.removeClass('nav__links--open');
            }
        });
    }
}